import { useCallback } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { SettingsModal, type SettingsSection } from './SettingsModal';

/**
 * Route des RÉGLAGES (`/parametres/:section`) — « tout dans l'URL ».
 *
 * `/parametres` redirige vers `/parametres/compte` (voir l'arbre de routes). Les
 * segments FR mappent les sections internes :
 *   `compte` → Compte   `apparence` → Apparence   `partages` → Mes partages
 *
 * Fermer revient à l'accueil. Un segment inconnu (dont l'ancien `donnees`, retiré)
 * est normalisé vers l'entrée par défaut (`/parametres/compte`).
 */

const SEGMENT_SECTION: Record<string, SettingsSection> = {
  compte: 'account',
  apparence: 'appearance',
  partages: 'shares',
};

const SECTION_SEGMENT: Record<SettingsSection, string> = {
  account: 'compte',
  appearance: 'apparence',
  shares: 'partages',
};

export function SettingsRoute(): React.JSX.Element {
  const { section } = useParams();
  const navigate = useNavigate();

  const onClose = useCallback(() => navigate('/'), [navigate]);
  const onSectionChange = useCallback(
    (next: SettingsSection) => navigate(`/parametres/${SECTION_SEGMENT[next]}`),
    [navigate],
  );

  const active = section ? SEGMENT_SECTION[section] : undefined;
  // Segment inconnu → normalise vers l'entrée par défaut.
  if (section !== undefined && active === undefined)
    return <Navigate to="/parametres/compte" replace />;

  return (
    <SettingsModal
      onClose={onClose}
      section={active ?? 'account'}
      onSectionChange={onSectionChange}
    />
  );
}
